import { useEffect, useState } from "react";
import PropTypes from "prop-types";

export const ElapsedTime = ({ buttons, videoRef }) => {
  const [remainingTime, setRemainingTime] = useState(0);
  useEffect(() => {
    videoRef.addEventListener("timeupdate", updateRemainingTime);
    return () => {
      videoRef.removeEventListener("timeupdate", updateRemainingTime);
    };
  }, []); //eslint-disable-line
  /* c8 ignore next 3 */
  const updateRemainingTime = () => {
    setRemainingTime(videoRef.duration - videoRef.currentTime);
  };
  const parseTimeFromNumberToTime = () => {
    const minutes = Math.floor(remainingTime / 60);
    const seconds = Math.floor(remainingTime % 60);
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };
  return (
    <>
      {buttons.time && (
        <div className={"ITXVideo__actionBar_Time hide_on_mobile "}>
          <span className={"body-s"}>
            {parseTimeFromNumberToTime() !== "00:00" ? "-" : ""}{" "}
            {parseTimeFromNumberToTime()}
          </span>
        </div>
      )}
    </>
  );
};
ElapsedTime.propTypes = {
  buttons: PropTypes.shape({
    time: PropTypes.bool.isRequired,
  }).isRequired,
  videoRef: PropTypes.object.isRequired,
};
